import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind-aware className combiner — the standard shadcn `cn` helper.
 * Mirrors `src/lib/utils.ts`; lives here so shadcn-style components placed in
 * the default `@/components/ui` path resolve `@/lib/utils` without changes.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
